import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { KeyValuePair } from '../../../models/common/keyValuePair';
import { ConfigurationService } from '../../../services/configuration.service';
import { AlertService } from '../../../services/alert.service';

@Component({
	selector: 'ztsi-salary-type-select',
	templateUrl: './ztsi-salary-type-select.component.html',
	styleUrls: ['./ztsi-salary-type-select.component.css'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ZtsiSalaryTypeSelectComponent),
			multi: true
		}
	]
})
export class ZtsiSalaryTypeSelectComponent implements ControlValueAccessor {

	types: KeyValuePair[] = [
		{ key: 'MONTHLY', value: 'Monthly' },
		{ key: 'NONE', value: 'Not Applicable' },
		{ key: 'PER_TRIP', value: 'Per Trip' }
	];

	@Input('value') _value: string;
	@Input() isDisabled: boolean = false;

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	constructor(
		private _configurationService: ConfigurationService,
		private _alertService: AlertService
	) { }

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	ngOnInit() {
		this._configurationService.getSalaryTypes().subscribe(response => {
			if (response.length != undefined) {
				this.types = response;
			}
			else {
				console.log('Unable to load salary type selection.');
			}

			if (this.value == undefined && this.types.length > 0) {
				this.value = this.types[0].key;
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-salary-type-select/ztsi-salary-type-select.component.ts